<template>
    <table class="table table-striped table-hover table-sm table-bordered mb-0">
        <tbody>
            <tr>
                <td class="w-75">
                    <div class="font-weight-bold">CARACTERIZADOS</div>
                    <span class="text-primary">Veri, Asig, Carac (Producto visible)</span>
                </td>
                <td class="text-center font-weight-bold align-middle align-middle">
                    {{ summaryInfo.caracterizados }}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="font-weight-bold">ASIGNADOS</div>
                    <span class="text-primary">Producto incompleto</span>
                </td>
                <td class="text-center font-weight-bold align-middle">
                    {{ summaryInfo.asignados }}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="font-weight-bold">VERIFICADOS</div>
                    <span class="text-primary">Existe</span>
                </td>
                <td class="text-center font-weight-bold align-middle">
                    {{ summaryInfo.verificados }}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="font-weight-bold">PRODUCTOS SIN DILIGENCIAR CON FDS</div>
                    <span class="text-primary">Veri, Asig</span>
                </td>
                <td class="text-center font-weight-bold align-middle">
                    {{ summaryInfo.con_FDS }}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="font-weight-bold">PRODUCTOS SIN DILIGENCIAR CON MSDS</div>
                    <span class="text-primary">Veri, Asig</span>
                </td>
                <td class="text-center font-weight-bold align-middle">
                    {{ summaryInfo.con_MSDS }}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="font-weight-bold">PRODUCTOS SIN DOCUMENTO</div>
                    <span class="text-primary">Veri, Asig</span>
                </td>
                <td class="text-center font-weight-bold align-middle">
                    {{ summaryInfo.sin_Docs }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'empresa-rpq-resumen',
    computed: {
        ...mapState('empresa', ['summaryInfo'])
    },
    methods: {
        ...mapActions('empresa', ['guardaDiligenciados'])
    }
};
</script>
